export const Solar = () => (
  <span role="img" aria-hidden className="anticon  ant-menu-item-icon">
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeLinecap="square" />
      <path
        d="M12 2V4M12 20V22M22 12H20M4 12H2M19.0711 4.92896L17.6569 6.34317M6.34326 17.6569L4.92904 19.0711M19.0711 19.0711L17.6569 17.6569M6.34326 6.34317L4.92904 4.92896"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
